import React from 'react'
import { Link } from '@mui/material';

const Tag = ({ model_name, id, children }) => {
  if (!id) return null
  return (
    <Link href={`/${model_name}/${id}`}>
      {children}
    </Link>
  )
}

export default React.memo(Tag)
